import React from 'react';
import { motion } from 'framer-motion';
import './Card.css';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'bordered' | 'elevated';
  padding?: 'none' | 'small' | 'medium' | 'large';
  onClick?: () => void;
  hoverable?: boolean;
  animateOnHover?: boolean;
}

const Card: React.FC<CardProps> = ({
  children,
  className = '',
  variant = 'default',
  padding = 'medium',
  onClick,
  hoverable = false,
  animateOnHover = true,
}) => {
  const cardClass = `card card-${variant} card-padding-${padding} ${
    hoverable ? 'card-hoverable' : ''
  } ${onClick ? 'card-clickable' : ''} ${className}`;

  const cardContent = (
    <div className={cardClass} onClick={onClick}>
      {children}
    </div>
  );

  if (animateOnHover && hoverable) {
    return (
      <motion.div
        whileHover={{ y: -4, transition: { duration: 0.2 } }}
        className="card-wrapper"
      >
        {cardContent}
      </motion.div>
    );
  }

  return cardContent;
};

export default Card;
